const mobileHeaderInit = () => {
    const mobileHeader = document.querySelector<HTMLElement>('.mobile-header');
    const mobileHeaderNavBtn = mobileHeader?.querySelector<HTMLElement>('.mobile-header-nav-btn');

    mobileHeaderNavBtn?.addEventListener('click', () => {
        const isExpanded = mobileHeaderNavBtn.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
            mobileHeaderNavBtn.setAttribute('aria-expanded', 'false');
            mobileHeaderNavBtn.classList.add('btn-skin-2', 'btn-inverted');
            mobileHeaderNavBtn.classList.remove('btn-skin-3');
            mobileHeader?.classList.remove('is-open');
            document.body.classList.remove('disable-scroll');
        } else {
            mobileHeaderNavBtn.setAttribute('aria-expanded', 'true');
            mobileHeaderNavBtn.classList.add('btn-skin-3');
            mobileHeaderNavBtn.classList.remove('btn-skin-2', 'btn-inverted');
            mobileHeader?.classList.add('is-open');
            document.body.classList.add('disable-scroll');
        }
    });
};

document.addEventListener('DOMContentLoaded', mobileHeaderInit);
